import React from "react";
import Styles from "./WhatDoWeOffer.module.css";
import { useTranslation } from "react-i18next";
import babylonGate from "../../assets/Images/babylonGate.svg";

function WhatDoWeOffer() {
  const { t, i18n } = useTranslation();

	  const isRtl =
			i18n.language === "ar" || i18n.language === "ku";


	return (
		<div
			className={Styles.Container}
		>
			<img
				className={Styles.image}
				src={babylonGate}
				alt='What do we offer'
			/>
			<div dir={isRtl ? "rtl" : "ltr"}>
				<h1
					className={Styles.h1}
				>
					{t("WhatDoWeOffer.title")}
				</h1>
				<p
					className={Styles.p}
				>
					{t("WhatDoWeOffer.content")}
				</p>
				{console.log(
					"List Items:",
					t("WhatDoWeOffer.listItems")
				)}

				<ul
					className={Styles.ul}
				>
					{t("WhatDoWeOffer.listItems", {
						returnObjects: true,
					}).map((item, index) => (
						<li
							className={Styles.li}
							key={index}
						>
							{item}
						</li>
					))}
				</ul>
			</div>
		</div>
	);
}

export default WhatDoWeOffer;
